module.exports = __webpack_public_path__ + "static/media/ne.3ea4495c.png";